// extracted by mini-css-extract-plugin
export default {"statistics":"Vacation_statistics__cycPe","highlighted":"Vacation_highlighted__SYoL-","number":"Vacation_number__jwL9R","fullWidth":"Vacation_fullWidth__Lpjed"};